import SingleDestination from "./SingleDestination";

export default SingleDestination;
